import { createRoot } from 'react-dom/client';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';  // ADD THIS
import { AuthProvider } from './components/auth/AuthContext';
import App from './App';

// Import styles
import './styles/auth/login.css';
import './styles/auth/signup.css';

// Global scrollbar styles injection
const globalScrollbarStyles = `
  * {
    scrollbar-width: thin;
    scrollbar-color: #555555 #2a2a2a;
  }

  *::-webkit-scrollbar {
    width: 6px;
  }

  *::-webkit-scrollbar-track {
    background: #2a2a2a;
    border-radius: 3px;
  }

  *::-webkit-scrollbar-thumb {
    background: #555555;
    border-radius: 3px;
  }

  *::-webkit-scrollbar-thumb:hover {
    background: #666666;
  }

  body {
    scrollbar-width: thin;
    scrollbar-color: #555555 #2a2a2a;
  }

  body::-webkit-scrollbar {
    width: 6px;
  }

  body::-webkit-scrollbar-track {
    background: #2a2a2a;
    border-radius: 3px;
  }

  body::-webkit-scrollbar-thumb {
    background: #555555;
    border-radius: 3px;
  }

  body::-webkit-scrollbar-thumb:hover {
    background: #666666;
  }
`;

// Inject the styles into the document
const styleElement = document.createElement('style');
styleElement.textContent = globalScrollbarStyles;
document.head.appendChild(styleElement);

// Get root container
const container = document.getElementById('root');
if (!container) {
    throw new Error('Root element not found');
}

// Create root and render app directly
const root = createRoot(container);

root.render(
    <HelmetProvider>
        <BrowserRouter>
            <AuthProvider>
                <App />
            </AuthProvider>
        </BrowserRouter>
    </HelmetProvider>
);